import { render } from "./UserMenu.vue?vue&type=template&id=fc0b2122"
import script from "./UserMenu.vue?vue&type=script&lang=js"
export * from "./UserMenu.vue?vue&type=script&lang=js"

import exportComponent from "/Users/ace/vscode/aau/scenario-maker/vendor/laravel/nova/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__file',"UserMenu.vue"]])

export default __exports__